import { openBlock as t, createElementBlock as e, createStaticVNode as l } from "vue";
const a = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 40 40"
}, c = /* @__PURE__ */ l('<path fill="#F0F0F0" d="M20 40c11.046 0 20-8.954 20-20S31.046 0 20 0 0 8.954 0 20s8.954 20 20 20Z"></path><path fill="#D80027" d="M0 20c0 7.58 4.218 14.176 10.435 17.568V2.432C4.218 5.824 0 12.419 0 20Z"></path><path fill="#D80027" d="M38.756 26.956A19.957 19.957 0 0 0 40 20c0-2.446-.44-4.79-1.244-6.956H1.244A19.954 19.954 0 0 0 0 20c0 2.446.44 4.79 1.244 6.956L20 28.696l18.756-1.74Z"></path><path fill="#6DA544" d="M20 40c8.6 0 15.93-5.428 18.756-13.044H1.244C4.07 34.572 11.401 40 20 40Z"></path><path fill="#D80027" d="M0 20c0 9.24 6.267 17.016 14.783 19.311V.689C6.267 2.984 0 10.759 0 20Z"></path><path fill="#F0F0F0" d="M12.236 8.801 10.39 6.956l-1.23 1.23-1.23-1.23-1.844 1.845 1.23 1.23-1.23 1.23 1.845 1.844 1.23-1.23 1.23 1.23 1.844-1.844-1.23-1.23 1.23-1.23Z"></path>', 6), o = [
  c
];
function h(p, n) {
  return t(), e("svg", a, [...o]);
}
const d = { render: h };
export {
  d as default,
  h as render
};
